import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import CallJoin from '../CallJoin';
import {
  isIOS,
  isAndroidChrome,
  getOpenInAppUrl,
} from '../../../helpers/serverRenderingUtils';
import { fetchCohostTopicName } from '../../user';

const mapDispatchToProps = dispatch => ({
  actions: {
    fetchCohostTopicName: webCohostTopicId =>
      dispatch(fetchCohostTopicName('', webCohostTopicId)),
  },
});

const mapStateToProps = ({ browser, station, user }, routerProps) => {
  const query =
    routerProps.location.search &&
    queryString.parse(routerProps.location.search);
  return {
    doRequireStation: query && query.match, // otherwise anonymous topic
    isIOS: isIOS(),
    isAndroidChrome: isAndroidChrome(),
    openInAppUrl: getOpenInAppUrl(
      `${routerProps.location.pathname}${routerProps.location.search}`
    ),
    station,
    user,
  };
};

class CohostJoinContainer extends Component {
  componentDidMount() {
    this.props.actions.fetchCohostTopicName(
      this.props.match.params.webCohostTopicId
    );
  }

  render() {
    const {
      doRequireStation,
      user: { cohostTopicName },
    } = this.props;
    return (
      <CallJoin {...this.props}>
        {cohostTopicName &&
          (doRequireStation ? (
            <p>
              is about to record a podcast segment about{' '}
              <strong>{cohostTopicName}</strong> and wants a cohost!
            </p>
          ) : (
            [
              <p>Someone wants to record a podcast episode with you about</p>,
              <h4>{cohostTopicName}</h4>,
              <p>Get the free Anchor app to join</p>,
            ]
          ))}
      </CallJoin>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CohostJoinContainer);
